import { useContext, useEffect, useState } from "react";
import "./style/Signup.css";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { AuthContext } from "./auth/AuthProvider";

let br = 1.0;
let intervalId = null;
export default function Signup() {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");

  const [error, setError] = useState("");
  const [exist, setExist] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userInfo1, setUserInfo1] = useState(null);

  const [validCode, setValidCode] = useState("");
  const [codeError, setCodeError] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  // const { loading, setLoading } = useContext(AuthContext);
  const [loading, setLoading] = useState(false); // ✅ local loading

  const navigate = useNavigate();

  const { setUser, user, apiUrl } = useContext(AuthContext);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("hero-text1");
          observer.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll(".loginSection").forEach((element) => {
      observer.observe(element);
    });
  }, []);

  if (loading) {
    return (
      <div className="spinner-wrapper">
        <FaSpinner className="spin" size={40} />
      </div>
    );
  }

  function googleButton() {
    // window.location.href =
    //   "https://api.introspecta.app/oauth2/authorization/google";
    window.location.href = `${apiUrl}/oauth2/authorization/google`;
  }

  function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);
    const formInfo = {
      email: email,
      username: username,
    };
    axios
      .post(apiUrl + "/api/auth/signup", formInfo, {
        withCredentials: true,
      })
      .then((response) => {
        setUserInfo(response.data);
        setLoading(false);

        setExist(false);
        setError("");
      })
      .catch((e) => {
        setExist(e.response.data);
        // setExist(true);
        // setError("Username or Email already exist!");
        console.error(e);
      })
      .finally(() => setLoading(false));
  }

  function handleSubmit1(e) {
    e.preventDefault();

    setLoading(true);

    // setUserInfo(null);
    const verCode = {
      email: email,
      verificationCode: code,
    };

    axios
      .post(apiUrl + "/api/auth/verify", verCode)
      .then((response) => {
        if (response.data !== null) {
          // setUserInfo1(response.data);
          setUser(response.data);

          // if (response.data.verificationCode !== verCode.verificationCode) {
          //   setCodeError("Invalid Code!");
          // } else {
          setLoading(false);
          setCodeError("");
          setCode("");
          const redirect = localStorage.getItem("postLoginRedirect");

          navigate(redirect || "/");

          localStorage.removeItem("postLoginRedirect");
          // navigate("/login");

          // }
        }
      })
      .catch((e) => {
        setCodeError(e.response.data.error);
        setCode("");

        setExist(true);
        // setError("Username or Email already exist!");
        console.error(e);
      })
      .finally(() => setLoading(false));
  }

  function handleSubmit2(e) {
    e.preventDefault();

    setLoading(true);

    const resendCode = {
      email: email,
    };

    const firstPartEmail = resendCode.email.split("@");

    axios
      .post(
        `${apiUrl}/api/auth/resend?email=${firstPartEmail[0]}%40${firstPartEmail[1]}`,
        resendCode,
      )
      .then((response) => {
        setLoading(false);
        setCodeError("");
        setCode("");
      })
      .catch((e) => {
        console.error(e);
        setCode("");
      })
      .finally(() => setLoading(false));
  }

  function handleCheckbox() {
    const checkbox = document.getElementById("legal-confirmation-submit");

    if (checkbox.checked) setIsChecked(true);
    else setIsChecked(false);
  }

  return (
    <>
      <section className="loginSection signup-page">
        <div id="goBackContainer">
          <Link to={localStorage.getItem("postLoginRedirect") || "/"}>
            <button id="goBackBtn">←</button>
          </Link>
        </div>
        <div className="signup-container">
          {!userInfo && (
            <form onSubmit={handleSubmit}>
              <label>Enter your Username:</label>
              <br></br>
              <input
                type="text"
                name="lUsername"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                style={{
                  borderColor:
                    exist === "Username already exists" ||
                    exist === "User already exists"
                      ? "red"
                      : "",
                  boxShadow:
                    exist === "Username already exists" ||
                    exist === "User already exists"
                      ? "0 0 10px red"
                      : "",
                }}
              />
              <br></br>
              <label>Enter your Email:</label>
              <br></br>
              <input
                type="email"
                name="lEmail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  borderColor:
                    exist === "Email already exists" ||
                    exist === "User already exists"
                      ? "red"
                      : "",
                  boxShadow:
                    exist === "Email already exists" ||
                    exist === "User already exists"
                      ? "0 0 10px red"
                      : "",
                }}
              />
              {exist ? (
                <p
                  style={{
                    color: "red",
                    marginBottom: "0",
                    opacity: br.toString(),
                  }}
                  className="invalidCode"
                >
                  {exist}
                </p>
              ) : (
                ""
              )}
              {isChecked ? (
                <input
                  type="submit"
                  value={"Submit"}
                  className="submit-type-btn"
                />
              ) : (
                <input
                  type="submit"
                  value={"Submit"}
                  className="submit-type-btn"
                  disabled
                />
              )}

              <div
                style={{
                  position: "relative",
                  top: "20px",
                }}
              >
                <p>
                  Already have an account?{" "}
                  <Link to={"/login"}>Log In Here</Link>
                </p>
              </div>
              <hr />

              <div className="legal-confirmation">
                <p style={{ marginBottom: "0", fontFamily: "helvetica" }}>
                  <input
                    type="checkbox"
                    id="legal-confirmation-submit"
                    onClick={handleCheckbox}
                  />
                  By clicking Submit, you agree to Introspecta's{" "}
                  <Link to={"/terms"}>Terms and Conditions</Link> and{" "}
                  <Link to={"/privacy"}>Privacy Policy</Link>.
                </p>
              </div>
            </form>
          )}
          {userInfo && (
            <form onSubmit={handleSubmit1}>
              <label>Email verification code for {userInfo.email}</label>
              <br></br>
              <input
                type="text"
                name="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
              />
              {exist ? (
                <p
                  className="invalidCode"
                  style={{ color: "red", marginBottom: "0" }}
                >
                  {codeError}
                </p>
              ) : (
                ""
              )}
              <input
                type="submit"
                value={"Verify Email"}
                className="submit-type-btn"
                // style={{ fontSize: "20px" }}
              />
            </form>
          )}

          {/* {userInfo1 && navigate("/login")} */}
          {!userInfo1 && userInfo && (
            <form onSubmit={handleSubmit2}>
              <input type="submit" value={"Resend Code"} id="resendCode" />
              <div
                style={{
                  position: "relative",
                  top: "20px",
                }}
              >
                <p>
                  Already have an account?{" "}
                  <Link to={"/login"}>Log In Here</Link>
                </p>
              </div>
            </form>
          )}

          {/* <div
            style={{
              position: "relative",
              top: "20px",
            }}
          >
            <p>
              Already have an account? <Link to={"/login"}>Log In Here</Link>
            </p>
          </div>
          <hr />
          <div className="legal-confirmation">
            <p style={{ marginBottom: "0", fontFamily: "helvetica" }}>
              <input
                type="checkbox"
                id="legal-confirmation-submit"
                onClick={handleCheckbox}
              />
              By clicking Submit, you agree to Introspecta's{" "}
              <Link to={"/terms"}>Terms and Conditions</Link> and{" "}
              <Link to={"/privacy"}>Privacy Policy</Link>.
            </p>
          </div> */}
          <div style={{ paddingTop: "5px" }}>
            <button
              type="button"
              className="login-with-google-btn"
              onClick={googleButton}
            >
              <img src="google.png" width={30} height={30} alt="google" />
              Sign in with Google
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
